import 'angular';

import { ApplyCreditsCtrl }           from './credits.apply';
import { CreditApplicationsListCtrl } from './credit-applications';
import { CreditStates }               from './credits.states.ajs';
import { CreditsCtrl }                from './credits';

angular.module('workshop.credits', [])
  .config(CreditStates)
  .controller('applyCreditsCtrl', ApplyCreditsCtrl)
  .controller('CreditsCtrl', CreditsCtrl)
  .controller('creditApplicationsListCtrl', CreditApplicationsListCtrl)
